import React from 'react';
import styles from './index.module.scss';

const Registered = () => (
	<div className={styles.root}>
		<small className={styles.copyright}>
			АНО «РИД “Новая газета”». Все права защищены. Адрес: 101000, Москва, Потаповский переулок, 3,
			строение 1. 18+.{' '}
			<a
				href='/terms'
				target='_blank'
				rel='noopener noreferrer'
				title='Пользовательское соглашение'
			>
				Пользовательское соглашение
			</a>
			.{' '}
			{/* <a
				href='/privacy'
				target='_blank'
				rel='noopener noreferrer'
				title='Политика конфиденциальности'
			>
				Политика конфиденциальности
			</a>
			. */}
		</small>
	</div>
);

export default Registered;
